<ng-container class="sales-order-form">
  <ng-container *ngTemplateOutlet="orderForm"></ng-container>
  <ng-container *ngTemplateOutlet="selfSaveButton"></ng-container>
</ng-container>

<ng-template #selfSaveButton>
  <div *ngIf="showSelfSaveButton" class="update-container">
    <button *ngIf="!submitting" mat-raised-button color="primary" (click)="clickUpdate()" [disabled]="submitting">
      {{ 'FRONTEND.SALES_UI.UPDATE_ORDER_FORM_ANSWERS' | translate }}
    </button>
    <div *ngIf="submitting">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
  </div>
</ng-template>

<ng-template #orderForm>
  <div *ngIf="orderData$ | async as orderData; else loading">
    <div
      class="sales-order-form-form"
      [hidden]="
        (loading$ | async) === false && orderData?.orderForms?.length === 0 && orderData?.extraQuestions?.length === 0
      "
    >
      <form [formGroup]="form">
        <store-order-form
          #vaOrderForm
          [orderForms]="orderData.orderForms"
          [fileUploadUrl]="fileUploadUrl"
          [commonData]="orderData.commonData"
          [productInfo]="orderData.productInfo"
          [parentForm]="form"
          [answers]="orderData.answers"
          [extraFields]="orderData.extraQuestions"
          [extraFieldsAnswers]="orderData.extraAnswers"
          [orderFormOptions]="orderData.orderFormOptions"
          [users]="orderData.users"
          [businessId]="businessId"
        ></store-order-form>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <div class="stencil-shimmer" *ngIf="loading$ | async"></div>
</ng-template>
